import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	filterInput: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		"& fieldset": {
			borderRadius: 3
		}
	},
	customFieldInput: {
		height: 56
	},
	deleteIcon: {
		borderRadius: "100%",
		width: theme.spacing(1.5),
		height: theme.spacing(1.5),
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[300]),
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[300])
		},
		"& svg": {
			width: theme.spacing(1.5),
			height: theme.spacing(1.5)
		}
	},
	deleteButton: {
		margin: theme.spacing(0, 2),
		padding: 0,
		height: theme.spacing(1.5),
		width: theme.spacing(1.5)
	}
}))

export default useStyles
